import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import Notification from '../Common/Notification';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxGym from '../../util/remote/ajaxGym';
import { useGym } from '../../DataStore/Gym/GymContext';
import AvatarPicker from '../AvatarPicker';

const NewTrainer = ({ show, onClose, onComplete }) => {
  const {getAvatarLibrary, avatarLibrary, getTrainerList} = useGym();
  const [formData, setFormData] = useState({
    full_name: '',
    specialization: '',
    phone_number: '',
    photo: ''
  });
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getAvatarLibrary();
  }, []);

  useEffect(() => {
    if (notify) {
      setTimeout(() => {
        setNotify(null);
      }, 5000);
    }
  }, [notify]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    if (loading) return;

    if (!formData.full_name || !formData.phone_number || !formData.specialization) {
      setNotify(<Notification type="danger" message="All fields are required." />);
      return;
    }

    if (!formData.photo) {
      setNotify(<Notification type="danger" message="Please select a trainer avatar." />);
      return;
    }

    setLoading(true);
    setNotify(null);

    const server_response = await ajaxGym.createTrainer({
      full_name: formData.full_name,
      phone_number: formData.phone_number,
      specialization: formData.specialization,
      photo: formData.photo.avatar_name,
    });

    setLoading(false);

    if (server_response.status === "OK") {
      getTrainerList();
      setFormData({ full_name: '', phone_number: '', specialization: '', photo: '' });
      setNotify(<Notification type='success' message={server_response.message} />);
      setTimeout(() => {
        onComplete(server_response.details);
        onClose();
      }, 2000);
    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };

  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Register New Trainer"
      footer={
        <>
          {!loading && (
            <>
              <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button
                className="btn btn-success"
                onClick={handleSubmit}
                disabled={!formData.full_name || !formData.phone_number || !formData.specialization}
              >
                <i className="fa fa-user-plus mr-1"></i> Register
              </button>
            </>
          )}
          {loading && <ActivityLoader />}
        </>
      }
    >
      {notify}

      <div className="form-group">
        <label className="font-weight-bold" htmlFor="full_name">
          <i className="fa fa-user text-primary mr-2"></i> Full Name:
        </label>
        <input
          type="text"
          className="form-control"
          id="full_name"
          name="full_name"
          value={formData.full_name}
          onChange={handleChange}
          placeholder="Enter full name"
          required
        />
      </div>

      <div className="form-group">
        <label className="font-weight-bold" htmlFor="phone_number">
          <i className="fa fa-phone text-primary mr-2"></i> Phone Number:
        </label>
        <input
          type="text"
          className="form-control"
          id="phone_number"
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          placeholder="Enter phone number"
          required
        />
      </div>

      <div className="form-group">
        <label className="font-weight-bold" htmlFor="specialization">
          <i className="fa fa-dumbbell text-primary mr-2"></i> Specialization:
        </label>
        <input
          type="text"
          className="form-control"
          id="specialization"
          name="specialization"
          value={formData.specialization}
          onChange={handleChange}
          placeholder="Enter area of specialization"
          required
        />
      </div>

      <AvatarPicker
        avatarLibrary={Array.isArray(avatarLibrary) ? avatarLibrary : []}
        selected={formData.photo}
        onSelect={(photo) => setFormData({ ...formData, photo })}
      />
    </BsModal>
  );
};

export default NewTrainer;
